<!-- Authord.by.KWShin.2024.03.14. -->
<template>
  <div class="h-100">
    <v-chart ref="chart" :options="options" :echart.sync="echart" />
  </div>
</template>

<script>
import { merge } from 'lodash';
import chartable from '@/mixins/chartable';

export default {
  mixins: [chartable],
  props: {
    motlet: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      options: {
        xAxis: {
          type: 'category',
          axisLabel: {
            fontWeight: 'normal',
            fontSize: 9,
            color: '#bbbbaa',
          },
        },
        yAxis: {
          nameGap: 7,
          nameTextStyle: {
            fontWeight: 'normal',
            fontSize: 11,
            color: '#bbbbaa',
          },
          minInterval: 1,
          axisLabel: {
            inside: true,
            showMinLabel: false,
            fontWeight: 'normal',
            fontSize: 9,
            color: '#bbbbaa',
          },
        },
        grid: {
          top: '5px',
          left: '18px',
          right: '11px',
          bottom: '16px',
        },
        barCategoryGap: '70%',
        barGap: '5%',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
      },
      echart: null,
    };
  },
  methods: {
    setOptions(options) {
      /*
       * Commented.by.KWShin.2024.03.14.
       * options를 다시 할당해주기 전에 반드시 X축 데이터와 Series 데이터와 Series 자체를 초기화해주어야 한다.
       * Vue Echart의 Porps options는 내부적으로 echart의 setOptions()에 매핑되는데,
       * 이 때 setOptions()의 패러미터 notMerge가 false이다.
       * 따라서, echart는 데이터가 바뀌어도 데이터의 주소가 바뀌지 않는 한 데이터가 바뀌지 않은 것으로 간주하고 update하지 않는다.
       * 물론, 마지막 줄에서 merge()를 호출하여 새로운 객체를 생성하여 할당해주고 있지만,
       * 웬일인지 그것은 동작하지 않는다. 위 세줄처럼 개별 데이터 변수를 다 초기화해주어야만 한다.
       */
      this.options.series = [];
      this.options.series?.forEach(s => (s.data = []));
      this.options.xAxis.data = [];
      this.options = merge({}, this.options, options);
    },
  },
};
</script>
